import { useIntl } from 'react-intl';

import { ErrorStateFallback } from '@/components/ui/error-state';
import { Header } from '@/components/ui/header';

import { LockedDashboard } from './freemium/locked-dashboard';
import { WelcomeBanner } from './freemium/welcome-banner';

/**
 * Free-tier home at `/openings`. The live dashboard is locked, so this page
 * shows the unlock banner and static previews of what a Source subscription
 * unlocks. Subscribed accounts do not land here.
 */
export function Openings() {
  const intl = useIntl();
  const openingsIntl = intl.formatMessage({
    defaultMessage: 'Openings',
    description:
      'Breadcrumb text for the sourcing home view on an account without a Source subscription',
  });

  return (
    <main className="flex flex-1 flex-col gap-4 px-6 py-2">
      <ErrorStateFallback>
        <Header headers={[{ title: openingsIntl }]} />
        <WelcomeBanner />
        <LockedDashboard />
      </ErrorStateFallback>
    </main>
  );
}
